export const requiredTimes = [
    {
        hour: 7,
        day: 0,
    },
    {
        hour: 8,
        day: 0,
    },
    {
        hour: 9,
        day: 0,
    },
    {
        hour: 13,
        day: 0,
    },
    {
        hour: 17,
        day: 0,
    },
    {
        hour: 19,
        day: 0,
    },
    {
        hour: 21,
        day: 0,
    },
    {
        hour: 7,
        day: 1,
    },
    {
        hour: 8,
        day: 1,
    },
    {
        hour: 9,
        day: 1,
    },
    {
        hour: 13,
        day: 1,
    },
    {
        hour: 17,
        day: 1,
    },
    {
        hour: 19,
        day: 1,
    },
    {
        hour: 21,
        day: 1,
    },
];
